import { createSelector } from '@reduxjs/toolkit';

const defaultFilters = {
  searchQuery: '',
  selectedSteps: [],
  selectedVendors: [],
  selectedDepartments: [],
  dateRange: {
    startingDate: null,
    endDate: null,
    formattedDate: {},
  },
};

const selectAllOrdersData = state => state.allOrders;

export const selectAllOrders = createSelector(
  selectAllOrdersData,
  state => state.data
);

export const selectIsLoading = createSelector(
  selectAllOrdersData,
  state => state.isLoading
);

export const selectCurrentPage = createSelector(
  selectAllOrdersData,
  state => state.pagination.pageNumber || 1
);

export const selectHasMore = createSelector(
  selectAllOrdersData,
  state => state.hasMore
);

export const isChangeStepStatusApiLoading = createSelector(
  selectAllOrdersData,
  state => state.changeStepStatus.isApiLoading
);

export const selectShowCancelSuccesful = createSelector(
  selectAllOrdersData,
  state => state.changeStepStatus.status === 200
);

export const selectShowCancelError = createSelector(
  selectAllOrdersData,
  state =>
    !!state.changeStepStatus.status && state.changeStepStatus.status !== 200
);

export const selectAllOrdersFiltersByCompany = companyId =>
  createSelector(
    selectAllOrdersData,
    state => state.filters.allOrders[companyId] || defaultFilters
  );

export const selectAllOrdersTotalWO = createSelector(
  selectAllOrdersData,
  state => state?.pagination?.totalResults
);

export const allOrdersStatus = createSelector(
  selectAllOrdersData,
  state => state.status
);

export const allOrdersSortEnabled = createSelector(
  selectAllOrdersData,
  state => state.sortEnabled
);

export const allOrdersSortField = createSelector(
  selectAllOrdersData,
  state => state.sortField
);

export const allOrdersSortBy = createSelector(
  selectAllOrdersData,
  state => state.sortBy
);
